export default "__VITE_ASSET__CVMv9JNP__"